// Page stylesheets also restyle html/body/navbar, so they must be in place before a
// route first paints; adding them after render caused a large layout shift.
// Each sheet is fetched once, kept in <head>, and toggled between inactive ("print")
// and active ("all") as routes mount and unmount.
const sheets = new Map();

function getSheet(name) {
  let sheet = sheets.get(name);
  if (!sheet) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `/styles/${name}?v=${import.meta.env.VITE_ASSET_VERSION}`;
    link.media = "print";
    link.fetchPriority = "high";
    link.dataset.pageStyle = name;
    const ready = new Promise((resolve) => {
      link.onload = resolve;
      link.onerror = resolve;
    });
    document.head.appendChild(link);
    sheet = { link, ready };
    sheets.set(name, sheet);
  }
  return sheet;
}

export function loadPageStyle(name) {
  return getSheet(name).ready;
}

export function activatePageStyle(name) {
  const { link } = getSheet(name);
  link.media = "all";
  return () => {
    link.media = "print";
  };
}
